import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { RentalListingDetailViewModel } from '@core/api';
import { Gallery, GalleryItem, ImageItem } from 'ng-gallery';
import { SearchService } from '../../../services/search.service';

@Component({
  selector: 'app-rental-item-details',
  templateUrl: './rental-item-details.component.html',
  styleUrls: ['./rental-item-details.component.scss'],
  standalone: false,
})
export class RentalItemDetailsComponent implements OnInit, OnChanges {
  @Input() location: RentalListingDetailViewModel & { city?: string };
  @Output() goBack = new EventEmitter<void>();
  @ViewChild('rentalItemDetails', { static: true })
  rentalItemDetails: ElementRef;

  selectedFile: string | null = null;
  galleryId: string;
  items: GalleryItem[];
  isDesktopView: boolean = true;

  constructor(
    public gallery: Gallery,
    private readonly searchService: SearchService
  ) {}

  ngOnInit() {
    this.initializeGalleryId();
    this.loadCityForLocation();
    this.initializeItems();
    this.loadGalleryItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.location?.currentValue) {
      this.initializeGalleryId();
      this.loadCityForLocation();
      this.initializeItems();
      this.loadGalleryItems();
    }
  }

  /**
   * Initializes the gallery ID based on the location ID.
   */
  private initializeGalleryId(): void {
    this.galleryId = `rentalItemLightbox${this.location.id}`;
  }

  /**
   * Initializes the gallery items based on the location files.
   */
  private initializeItems(): void {
    const imageFileExtensions = [
      'jpg',
      'jpeg',
      'png',
      'gif',
      'tif',
      'webp',
      'tiff',
    ];
    this.items = this.location.files
      ?.filter(file => {
        const fileExtension = file.fileName.split('.').pop().toLowerCase();
        return imageFileExtensions.includes(fileExtension);
      })
      .map(file => new ImageItem({ src: file.downloadUri, thumb: file.uri }));
  }

  /**
   * Loads the gallery items into the gallery reference.
   */
  private loadGalleryItems(): void {
    const galleryRef = this.gallery.ref(this.galleryId);
    galleryRef.setConfig({
      imageSize: 'contain',
      thumb: false,
      dots: true,
      counter: false,
    });
    galleryRef.load(this.items);
  }

  /**
   * Loads the city name for the current location based on its coordinates.
   */
  private loadCityForLocation(): void {
    this.searchService
      .getCityFromCoordinates(this.location.latitude, this.location.longitude)
      .then(city => {
        this.location.city = city;
      })
      .catch(error => {
        console.error('Error retrieving city:', error);
      });
  }

  /**
   * Opens the lightbox (for keyboard control)
   */
  openLightbox(index: number): void {
    const previews = document.querySelectorAll('.file-preview');
    const el = previews[index] as HTMLElement;
    if (el) {
      el.click();
    }
  }
}
